import { Module, PATH_DEFAULT_STORE_PROJECT_ASSIGNEES } from "@/constants";
import { DefaultStoreProjectAssigneeCreateResponse } from "@/types/defaultStoreProjectAssignee";
import { ApiError } from "@/services/api";
import { DefaultStoreProjectAssigneeCreate } from "@/types/defaultStoreProjectAssignee";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { useQueryCacheUpdater } from "@/hooks/useQueryCacheUpdater";
import { useTranslation } from "react-i18next";
import { DefaultStoreProjectAssigneesService } from "@/services/defaultStoreProjectAssignees";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";

export const useCreateDefaultStoreProjectAssignee = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { invalidateListQuery } = useQueryCacheUpdater(
    Module.DefaultStoreProjectAssignees,
  );
  const { t } = useTranslation();

  const mutation = useMutationWithErrorHandling<
    DefaultStoreProjectAssigneeCreateResponse,
    ApiError,
    DefaultStoreProjectAssigneeCreate,
    unknown
  >({
    mutationFn: (values) => DefaultStoreProjectAssigneesService.post(values),
    onSuccess: () => {
      navigate(PATH_DEFAULT_STORE_PROJECT_ASSIGNEES);
      toast({
        title: t("defaultStoreProjectAssignees.success.create"),
      });
      invalidateListQuery();
    },
    errorTitle: t("defaultStoreProjectAssignees.errors.create"),
  });

  return mutation;
};
